/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_Team_QInputs */

const en_mk_faq_team_q = /** @type {(inputs: Mk_Faq_Team_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do agents work together without overwriting each other’s code?`)
};

const id_mk_faq_team_q = /** @type {(inputs: Mk_Faq_Team_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana tim agent bekerja tanpa saling menimpa kode?`)
};

/**
* | output |
* | --- |
* | "How do agents work together without overwriting each other’s code?" |
*
* @param {Mk_Faq_Team_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_team_q = /** @type {((inputs?: Mk_Faq_Team_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_Team_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_team_q(inputs)
	return en_mk_faq_team_q(inputs)
});